import { render, staticRenderFns } from "./CsLink.vue?vue&type=template&id=7027c0fb&scoped=true&functional=true&lang=pug"
import script from "./CsLink.vue?vue&type=script&lang=ts"
export * from "./CsLink.vue?vue&type=script&lang=ts"
import style0 from "./CsLink.vue?vue&type=style&index=0&id=7027c0fb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7027c0fb",
  null
  
)

export default component.exports